import { BankAccountsView } from "./BankAccountsPage";

export default function PersonalBankingPage() {
  return (
    <BankAccountsView
      filterType="personal"
      title="Personal Banking"
      subtitle="Your personal accounts — kept separate from business BAS & P&L."
    />
  );
}
